import React from "react";
import MuiDialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/system";



const StyledDialogContent = styled(DialogContent)(() => ({
  padding: "20px",
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  padding: "16px 20px",
  fontSize: "1rem",
  fontWeight: 600,
  letterSpacing: "0.3px",
  borderBottom: "1px solid rgba(0,0,0,0.06)",
  background:
    "linear-gradient(180deg, rgba(248,250,252,0.95), rgba(240,244,248,0.95))",
}));



const Dialog = ({ open, handleClose, title, children }) => {
  const isEmpty =
    !title &&
    (!children ||
      (Array.isArray(children) && children.length === 0));

  if (!open || isEmpty) return null;

  return (
    <MuiDialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      aria-labelledby="dialog-title"
      PaperProps={{
        sx: {
          width: "fit-content",
          maxWidth: "95vw",
          borderRadius: "16px",
          overflow: "hidden",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(245,247,250,0.95))",
          boxShadow:
            "0 20px 50px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.6)",
        },
      }}
      sx={{
        backdropFilter: "blur(6px)",
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(15, 23, 42, 0.55)",
        },
      }}
    >
      {title && (
        <StyledDialogTitle id="dialog-title">
          {title}
        </StyledDialogTitle>
      )}

      {children && <StyledDialogContent>{children}</StyledDialogContent>}
    </MuiDialog>
  );
};

export default Dialog;
